module.exports = __webpack_public_path__ + "assets/img/compose-bg.79a88c41.png";